import { Button } from '@_shared/ui/Button';
import { Typography } from '@_shared/ui/Typography';
import { CheckCircleIcon, CheckIcon, RightChevronIcon } from '@_shared/icons';

import { useEffect, useState } from 'react';
import * as S from './TermsSlide.style';

export function TermsSlide({
	onNext,
	setTerms,
}: {
	onNext: () => void;
	setTerms: (terms: string[]) => void;
}) {
	const [allCheck, setAllCheck] = useState<boolean>(false);

	const [ageCheck, setAgeCheck] = useState<boolean>(false);
	const [serviceCheck, setServiceCheck] = useState<boolean>(false);
	const [personalCheck, setPersonalCheck] = useState<boolean>(false);
	const [marketingCheck, setMarketingCheck] = useState<boolean>(false);
	const [marketingPushCheck, setMarketingPushCheck] = useState<boolean>(false);

	useEffect(() => {
		if (
			!ageCheck ||
			!serviceCheck ||
			!personalCheck ||
			!marketingCheck ||
			!marketingPushCheck
		) {
			setAllCheck(false);
		}
	}, [ageCheck, serviceCheck, personalCheck, marketingCheck, marketingPushCheck]);

	return (
		<S.SlideContainer>
			<S.TermsSlide>
				<Typography type="headline-small" color="font-primary">
					이용약관에 <br />
					동의해 주세요
				</Typography>
				<S.TermsContainer>
					<S.TermsItem htmlFor="allTerms">
						<input
							type="checkbox"
							name="allTerms"
							id="allTerms"
							checked={allCheck}
							onInput={() => {
								setAllCheck((prev) => !prev);
								if (allCheck) {
									if (
										ageCheck &&
										serviceCheck &&
										personalCheck &&
										marketingCheck &&
										marketingPushCheck
									) {
										setAgeCheck(false);
										setServiceCheck(false);
										setPersonalCheck(false);
										setMarketingCheck(false);
										setMarketingPushCheck(false);
									}
								} else {
									setAgeCheck(true);
									setServiceCheck(true);
									setPersonalCheck(true);
									setMarketingCheck(true);
									setMarketingPushCheck(true);
								}
							}}
						/>
						<S.TermsItemAllCheckIconWrapper isActive={allCheck}>
							<CheckCircleIcon />
						</S.TermsItemAllCheckIconWrapper>
						<Typography type="title-large" color="font-secondary">
							전체 동의
						</Typography>
						<Typography type="title-medium" color="font-tertiary">
							(선택항목 포함)
						</Typography>
					</S.TermsItem>
					<S.SeperateLine />
					<S.TermsList>
						<S.TermsItem htmlFor="ageTerms">
							<input
								type="checkbox"
								name="ageTerms"
								id="ageTerms"
								checked={ageCheck}
								onInput={() => {
									setAgeCheck((prev) => !prev);
								}}
							/>
							<S.TermsItemIconWrapper isActive={ageCheck}>
								<CheckIcon />
							</S.TermsItemIconWrapper>

							<Typography type="title-medium" color="font-secondary">
								[필수] 만 14세 이상입니다.
							</Typography>
						</S.TermsItem>

						<S.TermsItem htmlFor="serviceTerms">
							<input
								type="checkbox"
								name="serviceTerms"
								id="serviceTerms"
								checked={serviceCheck}
								onInput={() => {
									setServiceCheck((prev) => !prev);
								}}
							/>
							<S.TermsItemIconWrapper isActive={serviceCheck}>
								<CheckIcon />
							</S.TermsItemIconWrapper>

							<Typography type="title-medium" color="font-secondary">
								[필수] 서비스 이용약관 동의
							</Typography>

							<S.TermsItemLinkIcon
								onClick={() => {
									window.location.href =
										'http://teamfore.notion.site/15c4abba6dbc4c788511d7466ca2a801?pvs=25';
								}}
							>
								<RightChevronIcon />
							</S.TermsItemLinkIcon>
						</S.TermsItem>

						<S.TermsItem htmlFor="personalTerms">
							<input
								type="checkbox"
								name="personalTerms"
								id="personalTerms"
								checked={personalCheck}
								onInput={() => {
									setPersonalCheck((prev) => !prev);
								}}
							/>
							<S.TermsItemIconWrapper isActive={personalCheck}>
								<CheckIcon />
							</S.TermsItemIconWrapper>

							<Typography type="title-medium" color="font-secondary">
								[필수] 개인정보 수집 및 이용 동의
							</Typography>

							<S.TermsItemLinkIcon
								onClick={() => {
									window.location.href =
										'https://teamfore.notion.site/61f78ba3a6924fe384b1ecb87bdab271?pvs=25';
								}}
							>
								<RightChevronIcon />
							</S.TermsItemLinkIcon>
						</S.TermsItem>

						<S.TermsItem htmlFor="marketingTerms">
							<input
								type="checkbox"
								name="marketingTerms"
								id="marketingTerms"
								checked={marketingCheck}
								onInput={() => {
									setMarketingCheck((prev) => !prev);
								}}
							/>
							<S.TermsItemIconWrapper isActive={marketingCheck}>
								<CheckIcon />
							</S.TermsItemIconWrapper>

							<Typography type="title-medium" color="font-secondary">
								[선택] 마케팅 활용 동의
							</Typography>

							<S.TermsItemLinkIcon
								onClick={() => {
									window.location.href =
										'https://teamfore.notion.site/e749ad0057564e09bb55ac73a9096f5b?pvs=4';
								}}
							>
								<RightChevronIcon />
							</S.TermsItemLinkIcon>
						</S.TermsItem>

						<S.TermsItem htmlFor="marketingPushTerms">
							<input
								type="checkbox"
								name="marketingPushTerms"
								id="marketingPushTerms"
								checked={marketingPushCheck}
								onInput={() => {
									setMarketingPushCheck((prev) => !prev);
								}}
							/>
							<S.TermsItemIconWrapper isActive={marketingPushCheck}>
								<CheckIcon />
							</S.TermsItemIconWrapper>

							<Typography type="title-medium" color="font-secondary">
								[선택] 마케팅 정보 수신 동의
							</Typography>

							<S.TermsItemLinkIcon
								onClick={() => {
									window.location.href =
										'https://teamfore.notion.site/e749ad0057564e09bb55ac73a9096f5b?pvs=4';
								}}
							>
								<RightChevronIcon />
							</S.TermsItemLinkIcon>
						</S.TermsItem>
					</S.TermsList>
				</S.TermsContainer>
			</S.TermsSlide>

			<S.BottomButtonContainer>
				<Button
					bgColor={
						!ageCheck || !serviceCheck || !personalCheck
							? 'warmgray-300'
							: 'orange-primary'
					}
					fullWidth
					disabled={!ageCheck || !serviceCheck || !personalCheck}
					onClick={() => {
						const termsList = [];

						if (marketingCheck) {
							termsList.push('TERMS01');
						}
						if (marketingPushCheck) {
							termsList.push('TERMS02');
						}

						setTerms(termsList);
						onNext();
					}}
				>
					<Typography type="title-large" color="white-primary">
						다음
					</Typography>
				</Button>
			</S.BottomButtonContainer>
		</S.SlideContainer>
	);
}
